import React from 'react';

export const IconPlayStep = () => {
    return (
        <svg fill="none" height="16" viewBox="0 0 16 16" width="40" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.5571 7.62037L3.8254 2.70748C3.50106 2.42948 3 2.65993 3 3.08711V12.9129C3 13.3401 3.50106 13.5705 3.8254 13.2925L9.5571 8.37963C9.78991 8.18008 9.78991 7.81992 9.5571 7.62037Z"
                stroke="#363E45"
                strokeWidth="1.5"
            />
            <path d="M13 2L13 14" stroke="#363E45" strokeLinecap="round" strokeWidth="1.5" />
        </svg>
    );
};
